// import { createStore, applyMiddleware, compose } from "redux";
// import createSagaMiddleware from "redux-saga";
// import reducers from "./reducers";
// import sagas from "./sagas";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// const sagaMiddleware = createSagaMiddleware();

// const persistConfig = {
//   key: "root",
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, reducers);

// const middlewares = [sagaMiddleware];
// export function configureStore(initialState) {
//   const store = createStore(
//     persistedReducer,
//     initialState,
//     compose(applyMiddleware(...middlewares))
//   );

//   sagaMiddleware.run(sagas);

//   if (module.hot) {
//     module.hot.accept("./reducers", () => {
//       // eslint-disable-next-line global-require
//       const nextRootReducer = require("./reducers");
//       store.replaceReducer(nextRootReducer);
//     });
//   }

//   let persistor = persistStore(store);

//   return { store, persistor };
// }

import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import menuReducer from "./slices/menuSlice";
import settingsReducer from "./slices/settingsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

// Combine reducers before applying persistReducer
const rootReducer = combineReducers({
  auth: authReducer,
  menu: menuReducer,
  settings: settingsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);
export { store, persistor };
